import React, {Component} from 'react';

import Workflow from "../core/Workflow";
import axios from "axios";
import AuthService from "../../AuthService";


class Anomalie extends Component {
    constructor(props) {
        super(props);

        this.wowkflow = React.createRef();

        this.state = {
            workflowInitData : {
                WORKFLOW_ID: 3,
                PARAM_anomalieId: this.props.match.params.anomalieId,
                PARAM_utilisateurId: 1, // TODO récupérer l'ID du localStorage stocké à partir du token
            },
            anomalieId: this.props.match.params.anomalieId,
        }
        
        this.coreChange = this.coreChange.bind(this);
        this.coreSubmit = this.coreSubmit.bind(this);
        this.coreExternalCall = this.coreExternalCall.bind(this);
    }

    coreChange(e) {
        if (e.target.name === "BLOCK_ITEM_3010101" && !(this.state.anomalieId) && !!(e.target.value)) {
            document.location = "/admin/anomalie/" + e.target.value;
        }
    }

    async coreExternalCall(method) {
        if (method === "delete") {
            await axios.post(AuthService.getUrl('/deleteAnomalie'), {id: this.state.anomalieId}, AuthService.getAuthHeader()).then(
                res => {
                    this.props.history.push('/admin/anomalies');
                }
            );
        }
        if (method === "close") {
            await axios.post(AuthService.getUrl('/endAnomalie'), {id: this.state.anomalieId}, AuthService.getAuthHeader()).then(
                res => {
                    document.location = "/admin/anomalie/" + this.state.anomalieId;
                }
            );
        }
        if (method === "leave") {
            this.props.history.push('/admin/anomalies');
        }
    }

    coreSubmit(data) {
        if (!!data) {
            data.screen.blocks[0].blockItems.map(blockItem => {
                if (blockItem.id === 300001) {
                    this.state.anomalieId = blockItem.values[0];
                }
            });
        }
    }

    render() {
        return (
            <div className="responsiveForm">
                {!!(this.state.errorMessage) &&
                    <div className="errorMessage">
                        <span>{this.state.errorMessage}</span>
                    </div>
                }
                {!!(this.state.validMessage) &&
                    <div className="actionMessage">
                        <span>{this.state.validMessage}</span>
                    </div>
                }
                <Workflow   ref={this.wowkflow}
                            initData={this.state.workflowInitData}
                            onChange={this.coreChange}
                            onSubmit={this.coreSubmit}
                            externalCall={this.coreExternalCall}
                            primaryKey={this.state.anomalieId}/>
            </div>
        );
    }
}

export default Anomalie;
